import { render, staticRenderFns } from "./DoctorsPinModal.vue?vue&type=template&id=1cb7e8a8&scoped=true"
import script from "./DoctorsPinModal.vue?vue&type=script&lang=js"
export * from "./DoctorsPinModal.vue?vue&type=script&lang=js"
import style0 from "./DoctorsPinModal.vue?vue&type=style&index=0&id=1cb7e8a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb7e8a8",
  null
  
)

export default component.exports